import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab, Dropdown, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import Airplane from "../assets/Airplane.png";
import AirplaneH from "../assets/AirplaneH.png";
import Hotel from "../assets/Hotel.png";
import HotelH from "../assets/HotelH.png";
import Calendar from "../assets/Calendar.png";
import Person from "../assets/Person.png";
import RvcBtn from "../assets/rvc-btn.png";
import TravelDatePicker from "./TravelDatePicker";
import GuestCounter from "./GuestCounter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MultiDatePicker from "./MultiDatePicker";


// import LoaderImg from "../assets/loader.gif"; // ✅ your bird loader image
import LoaderImg from "../assets/loader-img.mp4";


const TabsFlightHotal = () => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("flights");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

const location = useLocation();

  const handleSearch = (path) => {
    setLoading(true);
    setTimeout(() => {
      if (location.pathname === path) {
        setLoading(false); // Just hide loader if already on the same page
      } else {
        navigate(path);    // Navigate if different page (loader will auto-hide)
      }
    }, 2000);
  };

  // Ensure tab titles update on language change
  const tabTitles = {
    flights: t("Flights"),
    hotels: t("Hotels")
  };


  
  useEffect(() => {
    // This will force re-render on language change
    setActiveTab((prev) => prev);
  }, [i18n.language]);

  const [selectedTrip, setSelectedTrip] = useState(t("One-way"));

  /*******location dropdown */
  const [openFrom, setOpenFrom] = useState(false);
  const [openTo, setOpenTo] = useState(false);

  const fromRef = useRef(null);
  const toRef = useRef(null);

  const [fromLocation, setFromLocation] = useState({
    code: t("BOM"),
    name: t("Chhatrapati Shivaji Maharaj International Airport"),
  });

  const [toLocation, setToLocation] = useState({
    code: t("DEL"),
    name: t("Maharaj Holkar International Airport"),
  });

  useEffect(() => {
    setFromLocation({
      code: t("BOM"),
      name: t("Chhatrapati Shivaji Maharaj International Airport"),
    });
    setToLocation({
      code: t("DEL"),
      name: t("Maharaj Holkar International Airport"),
    });
  }, [i18n.language, t]);
  const handleFromSelect = (code, name) => {
    setFromLocation({ code, name });
    setOpenFrom(false);
  };
  const handleToSelect = (code, name) => {
    setToLocation({ code, name });
    setOpenTo(false);
  };
  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (fromRef.current && !fromRef.current.contains(event.target)) {
        setOpenFrom(false);
      }
      if (toRef.current && !toRef.current.contains(event.target)) {
        setOpenTo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

/*******location dropdown */
  const [openToLoc, setOpenToLoc] = useState(false);
  const toRefLoc = useRef(null);

  const [toLocationLoc, setToLocationLoc] = useState({
    code: t("DEL"),
  });

  useEffect(() => {
    setToLocationLoc({ code: t("DEL") });
  }, [i18n.language, t]);

  const handleToSelectLoc = (code) => {
    setToLocationLoc({ code });
    setOpenToLoc(false);
  };

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toRefLoc.current && !toRefLoc.current.contains(event.target)) {
        setOpenToLoc(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (selectedTrip === t("One-way", { lng: i18n.language === "en" ? "ar" : "en" })) {
      setSelectedTrip(t("One-way"));
    } else if (selectedTrip === t("Round-trip", { lng: i18n.language === "en" ? "ar" : "en" })) {
      setSelectedTrip(t("Round-trip"));
    } else if (selectedTrip === t("Multi-city", { lng: i18n.language === "en" ? "ar" : "en" })) {
      setSelectedTrip(t("Multi-city"));
    }
  }, [i18n.language]);

  return (
    <div className="banner-top-details-sec position-relative mb-0 pb-0">

      {loading && (
        <div className="loader-overlay">
             <video src={LoaderImg} autoPlay loop muted playsInline className="loader-video w-100 h-100" />
          {/* <img src={LoaderImg} alt="Loading..." className="loader-img" /> */}
          <p className="text-white mt-3">{t("Please wait, loading...")}</p>
        </div>
      )}


      <div className="container">
        <div className="inner-banner-top-details d-flex flex-wrap gap-2">
          {/* Tabs Left */}
          <div className="left-area">
            <Tabs
              id="bookingTabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="nav nav-tabs"
            >
              <Tab
                eventKey="flights"
                title={
                  <span className="booking-any d-flex align-items-center gap-1 justify-content-center">
                    <span className="normal-img">
                      <img src={Airplane} alt={t("Flights")} />
                    </span>
                    <span className="hover-img">
                      <img src={AirplaneH} alt={t("Flights Hover")} />
                    </span>
                    <span>{tabTitles.flights}</span>
                  </span>
                }
              ></Tab>
              <Tab
                eventKey="hotels"
                title={
                  <span className="booking-any d-flex align-items-center gap-1 justify-content-center">
                    <span className="normal-img">
                      <img src={Hotel} alt={t("Hotels")} />
                    </span>
                    <span className="hover-img">
                      <img src={HotelH} alt={t("Hotels Hover")} />
                    </span>
                    <span>{tabTitles.hotels}</span>
                  </span>
                }
              ></Tab>
            </Tabs>
          </div>

          {/* Tabs Right Content */}
          <div className="right-area flex-grow-1">
            {activeTab === "flights" && (
              <div className="tab-pane fade show active">
                <div className="d-flex flex-wrap gap-2">
                  {/* Trip Type Dropdown */}
                  <div className="drop-one-way">
                    <Dropdown>
                      <Dropdown.Toggle className="btn btn-secondary d-flex align-items-center gap-2 bg-transparent border-0">
                        <svg
                          width="16"
                          height="10"
                          viewBox="0 0 16 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1.5L8 8.5L15 1.5"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                        {selectedTrip}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="mt-0 drop-border-box">
                        <Dropdown.Item
                          onClick={() => setSelectedTrip(t("Round-trip"))}
                          className=" text-decoration-none bg-transparent"
                        >
                          {t("Round-trip")}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => setSelectedTrip(t("One-way"))}
                          className=" text-decoration-none bg-transparent"
                        >
                          {t("One-way")}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => setSelectedTrip(t("Multi-city"))}
                          className=" text-decoration-none bg-transparent"
                        >
                          {t("Multi-city")}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {/* Location From / To */}
                  <div className="location-sec d-flex align-items-center gap-2">
                    <div
                      className="location-box btn-border-box position-relative"
                      ref={fromRef}
                    >
                      <div
                        className="cursor-pointer"
                        onClick={() => setOpenFrom(!openFrom)}
                        aria-expanded={openFrom}
                      >
                        <p>{t("Leaving From")}</p>
                        <div className="till-box d-flex align-items-center gap-1">
                          <h6>{fromLocation.code}</h6>
                          <span>{fromLocation.name}</span>
                        </div>
                      </div>

                      {/* Dropdown menu */}
                      {openFrom && (
                        <div className="dropdown-menu w-100 left-fixed-box p-2 mt-2 show">
                          <div
                            className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                            onClick={() => handleFromSelect(
                              t("BOM"),
                              t("Chhatrapati Shivaji Maharaj International Airport")
                            )}
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("BOM")}</h6>
                              <span>{t("Chhatrapati Shivaji Maharaj International Airport")}</span>
                            </div>
                          </div>
                          <div
                            className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                            onClick={() => handleFromSelect(
                              t("GUT"),
                              t("Chhatrapati Shivaji Maharaj International Airport")
                            )}
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("GUT")}</h6>
                              <span>{t("Chhatrapati Shivaji Maharaj International Airport")}</span>
                            </div>
                          </div>
                          <div
                            className="cursor-pointer location-list pb-2"
                            onClick={() => handleFromSelect(
                              t("DEL"),
                              t("Maharaj Holkar International Airport")
                            )}
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("DEL")}</h6>
                              <span>{t("Maharaj Holkar International Airport")}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <a href="#" className="rvc-btn">
                      <img src={RvcBtn} alt="swap" />
                    </a>

                    <div
                      className="location-box btn-border-box position-relative"
                      ref={toRef}
                    >
                      <div
                        className="cursor-pointer"
                        onClick={() => setOpenTo(!openTo)}
                        aria-expanded={openTo}
                      >
                        <p>{t("Going To")}</p>
                        <div className="till-box d-flex align-items-center gap-1">
                          <h6>{toLocation.code}</h6>
                          <span>{toLocation.name}</span>
                        </div>
                      </div>

                      {/* Dropdown menu */}
                      {openTo && (
                        <div className="dropdown-menu w-100 left-fixed-box p-2 mt-2 show">
                          <div
                            className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                            onClick={() =>
                              handleToSelect(
                              t("BOM"),
                              t("Chhatrapati Shivaji Maharaj International Airport")
                              )
                            }
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("BOM")}</h6>
                              <span>
                                {t("Chhatrapati Shivaji Maharaj International Airport")}
                              </span>
                            </div>
                          </div>
                          <div
                            className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                            onClick={() =>
                              handleToSelect(
                                t("GUT"),
                                t("Chhatrapati Shivaji Maharaj International Airport")
                              )
                            }
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("GUT")}</h6>
                              <span>
                                {t("Chhatrapati Shivaji Maharaj International Airport")}
                              </span>
                            </div>
                          </div>
                          <div
                            className="cursor-pointer location-list pb-2"
                            onClick={() =>
                              handleToSelect(
                                t("DEL"),
                                t("Maharaj Holkar International Airport")
                              )
                            }
                          >
                            <div className="till-box d-flex align-items-center gap-1">
                              <h6>{t("DEL")}</h6>
                              <span>{t("Maharaj Holkar International Airport")}</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Calendar + Travelers */}
                  <div className="calendar-add-sec d-flex align-items-center gap-2 flex-md-nowrap flex-wrap">
                    <TravelDatePicker />
                    <GuestCounter />
                  </div>

                  <div className="btn-btn-box">
                     <button
                      className="btn btn-primary"
                      onClick={() => handleSearch("/flights")}
                      disabled={loading}
                    >
                      {t("Search")}
                    </button>
                  </div>
                  
                </div>
              </div>
            )}

            {activeTab === "hotels" && (
              <div className="tab-pane fade show active hotel-box">
                <div className="d-flex flex-wrap gap-2">
                 <div className="location-sec d-flex align-items-center gap-2 ">
                  <div
                    className="location-box btn-border-box position-relative w-100"
                    ref={toRefLoc}
                  >
                    <div
                      className="cursor-pointer"
                      onClick={() => setOpenToLoc(!openToLoc)}
                      aria-expanded={openToLoc}
                    >
                      <p>{t("City")}</p>
                      <div className="till-box d-flex align-items-center gap-1">
                        <h6>{toLocationLoc.code}</h6>
                      </div>
                    </div>

                    {/* Dropdown menu */}
                    {openToLoc && (
                      <div className="dropdown-menu w-100 left-fixed-box p-2 mt-2 show">
                        <div
                          className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                          onClick={() => handleToSelectLoc(t("BOM"))}
                        >
                          <div className="till-box d-flex align-items-center gap-1">
                            <h6>{t("BOM")}</h6>
                          </div>
                        </div>
                        <div
                          className="cursor-pointer location-list pb-2 mb-2 border-bottom"
                          onClick={() => handleToSelectLoc(t("GUT"))}
                        >
                          <div className="till-box d-flex align-items-center gap-1">
                            <h6>{t("GUT")}</h6>
                          </div>
                        </div>
                        <div
                          className="cursor-pointer location-list pb-2"
                          onClick={() => handleToSelectLoc(t("DEL"))}
                        >
                          <div className="till-box d-flex align-items-center gap-1">
                            <h6>{t("DEL")}</h6>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                  <div className="calendar-add-sec d-flex align-items-center gap-2 flex-md-nowrap flex-wrap">
                    <MultiDatePicker />
                    <GuestCounter />
                  </div>

                  <div className="btn-btn-box">
                    <button
                      className="btn btn-primary"
                      onClick={() => handleSearch("/hotel")}
                      disabled={loading}
                    >
                      {t("Search")}
                    </button>
                  </div>
                  
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabsFlightHotal;
